import React from 'react'
import { connect } from 'react-redux'
import LinearProgress from 'material-ui/LinearProgress'

const styles = {
  padding: 5,
  progress: {
    height: '8px',
  },
}

class ExpProgress extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      experiencie: props.user.relative_current_experience,
      next_lvl_experiencie: props.user.relative_next_level_experience,
      level: props.user.level,
      color: '#f79410',
      levelup: false,
      color_level: '#000000',
    }
  }

  componentDidMount() {
    const exp_to_add = this.props.experience_to_add
    this.timer = setTimeout(() =>
      this.setState({ color: '#00c853' }, () =>
        this.addExp(exp_to_add),
      )
    , 800)
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  addExp(exp_to_add) {
    const current_exp = this.state.experiencie + exp_to_add
    if (current_exp < this.state.next_lvl_experiencie) {
      this.setState({ experiencie: current_exp }, () =>
        setTimeout(() => this.setState({ color: '#f79410' }), 500),
      )
    } else {
      const new_exp = current_exp - this.state.next_lvl_experiencie
      this.setState({ experiencie: this.state.next_lvl_experiencie }, () =>
        setTimeout(() => {
          this.setState({
            levelup: true,
            experiencie: 0,
            next_lvl_experiencie: this.props.user.relative_next_of_next_level_experience,
            level: this.state.level + 1,
            color_level: '#00c853',
          }, () =>
            setTimeout(() =>
              this.setState({
                experiencie: new_exp,
              }, () =>
                setTimeout(() => this.setState({
                  color: '#f79410',
                  color_level: '#000000',
                }), 500),
              )
            , 500),
          )
        }
        , 500),
      )
    }
  }

  linear_progress = () => {
    if (this.state.levelup) {
      return (<LinearProgress
        key={0}
        color={this.state.color}
        mode="determinate"
        max={this.state.next_lvl_experiencie}
        value={this.state.experiencie}
        style={styles.progress}
      />)
    }
    return (<LinearProgress
      key={1}
      color={this.state.color}
      mode="determinate"
      max={this.state.next_lvl_experiencie}
      value={this.state.experiencie}
      style={styles.progress}
    />)
  }


  render() {
    return (
      <div>
        <div
          style={styles}
          className="mui--text-headline mui--text-center"
        >
          Nivel
          <span style={{ color: this.state.color_level }}>
            {` ${this.state.level}`}
          </span>
        </div>
        {this.linear_progress()}

      </div>
    )
  }
}

ExpProgress.propTypes = {
  experience_to_add: React.PropTypes.Number,
  user: React.PropTypes.shape({
    relative_current_experience: React.PropTypes.Number,
    relative_next_level_experience: React.PropTypes.Number,
    level: React.PropTypes.Number,
    relative_next_of_next_level_experience: React.PropTypes.Number,
  }),
}

const mapStateToProps = state => ({
  experience_to_add: state.missions.answerMission.progress.earned_for_winning.experience_to_add,
  user: state.missions.answerMission.progress.earned_for_winning.user,
})

const mapDispatchToProps = () => ({})


export default connect(mapStateToProps, mapDispatchToProps)(ExpProgress)



// WEBPACK FOOTER //
// ./src/components/MissionFinish/ExpProgress/index.jsx